import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiArrowRight } = FiIcons;

const HomeFinalCTA = () => {
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  return (
    <section className="py-24" style={{ background: '#052e16' }}>
      <div className="max-w-4xl mx-auto px-8 lg:px-16 text-center">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
          <h2 className="text-3xl md:text-4xl font-bold mb-5 text-white">
            If your team is tracking assets in spreadsheets and losing support requests in email — let's fix that.
          </h2>
          <p className="text-base mb-10 max-w-2xl mx-auto" style={{ color: '#bbf7d0' }}>
            JSM-based asset management and internal helpdesk for operations and IT teams at asset-heavy companies. Fixed-fee build. Monthly retainer. AI voice intake available as an add-on.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button onClick={() => scrollTo('booking')} className="group inline-flex items-center justify-center gap-2 px-8 py-4 rounded font-bold text-base" style={{ background: '#16a34a', color: '#ffffff' }}>
              Book a Discovery Call
              <SafeIcon icon={FiArrowRight} className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </button>
            <button onClick={() => scrollTo('booking')} className="px-8 py-4 rounded font-bold text-base"
              style={{ background: 'rgba(255,255,255,0.07)', color: '#ffffff', border: '1px solid rgba(255,255,255,0.2)' }}>
              Talk Through Your Setup
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default HomeFinalCTA;